// databaseSettingsTabs.js

export const SETTINGS_TAB_ABOUT = 'about';
export const SETTINGS_TAB_FIELDS = 'fields';
export const SETTINGS_TAB_RELATED = 'related';
export const SETTINGS_TAB_VIEW_GROUPS = 'view_groups';
export const SETTINGS_TAB_VIEWS = 'views';
export const SETTINGS_TAB_FORMS = 'forms';
export const SETTINGS_TAB_WORKFLOWS = 'workflows';
/** @deprecated Use SETTINGS_TAB_WORKFLOWS — kept for restore-era callers. */
export const SETTINGS_TAB_MISSIONS = SETTINGS_TAB_WORKFLOWS;
export const SETTINGS_TAB_ROLLUPS = 'rollups';
export const SETTINGS_TAB_AUTOMATIONS = 'automations';

export const normalizeSettingsTab = (value, { fallback = SETTINGS_TAB_ABOUT } = {}) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === SETTINGS_TAB_FIELDS) return SETTINGS_TAB_FIELDS;
  if (normalized === SETTINGS_TAB_RELATED) return SETTINGS_TAB_RELATED;
  if (normalized === SETTINGS_TAB_VIEW_GROUPS || normalized === 'viewgroups') {
    return SETTINGS_TAB_VIEW_GROUPS;
  }
  if (normalized === SETTINGS_TAB_VIEWS) return SETTINGS_TAB_VIEWS;
  if (normalized === SETTINGS_TAB_FORMS) return SETTINGS_TAB_FORMS;
  if (normalized === SETTINGS_TAB_WORKFLOWS || normalized === 'missions') {
    return SETTINGS_TAB_WORKFLOWS;
  }
  if (normalized === SETTINGS_TAB_ROLLUPS) return SETTINGS_TAB_ROLLUPS;
  if (normalized === SETTINGS_TAB_AUTOMATIONS) return SETTINGS_TAB_AUTOMATIONS;
  if (normalized === SETTINGS_TAB_ABOUT) return SETTINGS_TAB_ABOUT;
  return fallback;
};
